import React from 'react';
import '../styles/Alerts.css';
import { FaCheck } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import { useTranslation } from '../context/TranslationContext';
import { translateAlertMessage } from '../helpers/clientDisplayHelper';

const Alerts = ({ alerts, clientName }) => {
  const { t } = useTranslation();

  return (
    <div className="alerts-container">
      {Array.isArray(alerts) && alerts.length > 0 ? (
        alerts.map((alert, index) => {
          let icon =  <IoIosWarning className='colorYellow' />;
    

          switch (alert.level) {
            case 'HIGH':
              icon = <IoIosWarning className='colorRed' />;
              break;
            case 'MEDIUM':
              icon = <IoIosWarning className='colorOrange' />;
              break;
            case 'LOW':
              icon = <IoIosWarning className='colorYellow' />;
              break;
            default:
              break;
          }

          return (
            <div className='alert-item' key={index}>
              {icon} {translateAlertMessage(alert.message, t)}
            </div>
          );
        })
      ) : (
        <p className='alert-item'><FaCheck className='colorGreen' /> {t("alerts.none")}</p>
      )}
    </div>

  );
};

export default Alerts;
